// 登录
import service from '@/utils/request'

export function provinceCity(data) {
    return service({
        url: '/service/app/province_city',
        method: 'post',
        params: data
    })
}
export function province(data) {
    return service({
        url: '/service/app/province',
        method: 'post',
        params: data
    })
}
export function city(data) {
    return service({
        url: '/service/app/city',
        method: 'post',
        params: data
    })
}
export function area(data) {
    return service({
        url: '/service/app/area',
        method: 'post',
        params: data
    })
}
export function getWzArea(data) {
    return service({
        url: '/service/admin/getWzArea',
        method: 'get',
        params: data
    })
}

export function getAllWzArea(data) {
  return service({
      url: '/service/admin/getWzAllArea',
      method: 'get',
      params: data
  })
}
